module.exports = __webpack_public_path__ + "img/52ne.5c0cc29f.svg";